import React, { useState } from "react";
import axios from "axios";

const Form = () => {
  const [contact, setContact] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [sendMessage, setSendMessage] = useState(false)
  const [sending, setSending] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true)
    axios({
      method: "POST",
      url: "https://makomechanical.ca/message/send/",
      data: contact,
    }).then((response) => {
      if (response.data.status === "success") {
        setSending(false)
        setSendMessage(true)
        setTimeout(() => {
          setSendMessage(false)
        }, 3000);    
        setContact({ name: "", phone: "", email: "", message: "" });
      } else if (response.data.status === "error") {
        alert("Message failed to send.");
      }
    });
  };
  return (
    <>
    <div className="w-screen mt-5 lg:mt-10 relative">
    {sendMessage ?
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 bg-white shadow-lg px-5 py-5 flex justify-center items-center gap-4 w-10/12 lg:w-96 mx-auto rounded-lg border" role="alert">
    <img src="assets/logos/logo-nav.svg" alt="logo" className=" w-28" />
    <div>
    <p className="font-bold text-xl">Thank you</p>
    <p className="text-sm">Thank you for your message.It has been sent.</p>
    </div>
    </div>
    :<></>
    }
    {sending ?
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 bg-white shadow-lg px-5 py-5 flex justify-center items-center gap-4 w-10/12 lg:w-96 mx-auto rounded-lg border" role="alert">
        <img src="assets/logos/logo-nav.svg" alt="logo" className="w-28" />
        <div>
          <svg role="status" class="w-8 h-8 mr-2 animate-spin dark:text-gray-600 fill-blue" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>
          </svg>
        </div>
        </div>
        :<></>
      }
        <div className="block p-6 rounded-lg  w-full lg:w-2/3 max-w-xl mx-auto">
          <div className="hidden xl:flex justify-center items-center -z-10 absolute top-1/2 right-0 bottom-7 2xl:bottom-[68px] transform rotate-1 2xl:right-28">
            <picture>
                <source type="image/webp" alt="mako-truck" srcset="assets/images/truck.webp" className="w-10/12 2xl:w-full object-cover drop-shadow-[5px_7px_3px_rgba(0,0,0,0.25)]"  />
                <img src="assets/images/truck.png" alt="makotruck" className="w-10/12 2xl:w-full object-cover drop-shadow-[5px_7px_3px_rgba(0,0,0,0.25)]" />
              </picture>
          </div>
          <form onSubmit={handleSubmit} method="POST">
            <div className="form-group mb-6 relative z-20">
              <input
                type="text"
                required
                className="
                        form-control block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                id="name"
                placeholder="NAME"
                name="name"
                onChange={(e) =>
                  setContact({ ...contact, [e.target.name]: e.target.value })
                }
                value={contact.name}
              />
            </div>
            <div className="form-group mb-6">
              <input
                type="text"
                required
                className="form-control block
          w-full
          px-3
          py-1.5
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          m-0
          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                id="phone"
                placeholder="PHONE"
                name="phone"
                value={contact.phone}
                onChange={(e) =>
                  setContact({ ...contact, [e.target.name]: e.target.value })
                }
              />
            </div>

            <div className="form-group mb-6">
              <input
                type="email"
                required
                className="form-control block
          w-full
          px-3
          py-1.5
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          m-0
          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                id="email"
                placeholder="E-MAIL"
                name="email"
                value={contact.email}
                onChange={(e) =>
                  setContact({ ...contact, [e.target.name]: e.target.value })
                }
              />
            </div>
            <div className="form-group mb-6">
              <textarea
                required
                className="
          form-control
          block
          w-full
          px-3
          py-1.5
          text-base
          font-normal
          text-gray-700
          bg-white bg-clip-padding
          border border-solid border-gray-300
          rounded
          transition
          ease-in-out
          m-0
          focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
        "
                id="message"
                rows="3"
                placeholder="MESSAGE"
                name="message"
                value={contact.message}
                onChange={(e) =>
                  setContact({ ...contact, [e.target.name]: e.target.value })
                }
              ></textarea>
            </div>
            <div className="flex justify-center">
              <button
                className="text-white bg-blue font-work font-semibold py-2 px-9 text-md rounded-sm tracking-widest hover:-translate-y-1 transition-all hover:bg-aqua shadow-md"
                type="submit"
              >
                SUBMIT
              </button>
            </div>
          </form>
        </div>
    </div>
    </>
  );
};

export default Form;
